import { axios } from '@Root/API'

export const remove = engagementId => {
	return axios.delete(`student-engagement/${engagementId}/collaborative-provision`)
}
